import { timeFormat } from 'ty-vue-filters'
import { HosCache } from './cache'

/**
 * 判断浏览器类型
 * @param name
 * iphone
 * android
 * micromessenger 微信端
 * mozilla chorme浏览器 app端用的也是这个
 * alipayclient 支付宝
 * @returns {boolean}
 */
export function isBrower (name) {
  let UA = window.navigator.userAgent.toLowerCase()
  // console.log('【浏览器】',UA)
  return UA.indexOf(name) > -1
}

/**
 * 获得浏览器
 * @returns {string}
 */
export function getBrower () {
  return isBrower('micromessenger') ? 'micromessenger' : isBrower('alipayclient') ? 'alipay' : 'other'
}

/**
 * 生成返回URL
 * @param options
 * @returns {string}
 */
export function makeUrl (options) {
  let url = ''
  if (options.protocol) {
    url += options.protocol + '://'
  }
  if (options.hostname) {
    url += options.hostname
  }
  if (options.port && options.port != 80 && options.port != 443) {
    url += ':' + options.port
  }
  if (options.path) {
    url += options.path
  }
  if (options.query) {
    let q = ''
    for (let key in options.query) {
      if (options.query[key]) {
        q += `&${key}=${options.query[key]}`
      } else {
        q += `&${key}`
      }
    }
    q = q.substr(1)
    url += '?' + q
  }
  if (options.hash) {
    url += '#' + options.hash
  }
  return url
}

/**
 * 解析url参数
 * @param from
 * @returns {{protocol: *, hostname: *, port: *, path: *, query: *, hash: *}}
 */
export function getParamsFromUrl (from) {
  let protocol = url('protocol', from)
  let hostname = url('hostname', from)
  let port = url('port', from)
  let path = url('path', from)
  let query = url('?', from)
  let hash = url('hash', from)
  return { protocol, hostname, port, path, query, hash }
}

// str表示要转换的字符串
export function transferFormat (str = '') {
  return str.replace(/\n|\r\n|↵/g, '<br/>').replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
}

export function html2Text (htmlstr) {
  let div = document.createElement('div')
  div.innerHTML = htmlstr
  let res = div.innerText.replace(/[↵\s\n\r]/g, '')
  res.indexOf('http') > -1 && (res = '[外链文章]')
  return res
}

// html转为纯文本
export function html2PureText (htmlstr) {
  let div = document.createElement('div')
  div.innerHTML = htmlstr
  let res = div.innerText.replace(/<[^>]*>|\n|&nbsp|\r|\t/g, '')
  return res
}

/**
 *获得环境变量
 */
export function getENV () {
  let host = url('hostname')
  return appConfig.env[host] ? appConfig.env[host] : appConfig.env['localhost']
}

/**
 * 读取上传的图片
 * @param file
 * @returns {Promise<any>}
 */
export function readFile (file) {
  return new Promise((resolve, reject) => {
    let fr = new FileReader()
    fr.readAsDataURL(file)
    fr.onload = () => {
      resolve(fr.result)
    }
    fr.onerror = (e) => {
      reject(e)
    }
  })
}

/**
 * @param timer
 * @returns {Promise<any>}
 */
export function sleep (timer) {
  return new Promise(resolve => {
    setTimeout(resolve(1), timer)
  })
}

/**
 * 读取图片
 * @param url
 * @returns {Promise<any>}
 */
export function readImg (url) {
  let img = new Image()
  return new Promise((resolve, reject) => {
    img.src = url
    img.onload = () => {
      resolve(img)
    }
    img.onerror = (error) => {
      Log('图片加载错误', error)
      reject(error)
    }
  })
}

/**
 * @desc 实现图片预加载
 * @param images
 * @returns {Promise<any>}
 */
export function preloadImg (images) {
  const iterable = []
  for (let i = 0; i < images.length; i++) {
    iterable[i] = new Promise((resolve, reject) => {
      const image = new Image()
      image.src = images[i]
      image.onload = function () {
        resolve(this)
      }
    })
  }
  return Promise.all(iterable)
}

/**
 * @desc 修改浏览器标题兼容微信ios
 * @param title
 * @returns {void}
 */
export function setTitle (title) {
  document.title = title
  // 针对微信中的处理
  const iframe = document.createElement('iframe')
  iframe.src = ''
  iframe.style.display = 'none'
  iframe.onload = () => {
    setTimeout(() => {
      iframe.remove()
    }, 0)
  }
  document.body.appendChild(iframe)
}

/**
 * @description 在多少天内
 * @param dateRange
 * @param barrier 间隔符号
 * @returns {array<string>}
 */

export function inDays (dateRange, barrier = '') {
  let now = Date.now()
  let timestamp = 24 * 60 * 60 * 1000
  let start = now - dateRange[0] * timestamp
  let end = now - dateRange[1] * timestamp
  if (barrier) {
    return [timeFormat(end, `%Y${barrier}%m${barrier}%d`), timeFormat(start, `%Y${barrier}%m${barrier}%d`)]
  } else {
    return [timeFormat(end, '%Y%m%d'), timeFormat(start, '%Y%m%d')]
  }
}

export function go (url, $router) {
  if (/^javas/.test(url) || !url) return
  const useRouter = typeof url === 'object' || ($router && typeof url === 'string' && !/http/.test(url))
  if (useRouter) {
    if (typeof url === 'object' && url.replace === true) {
      $router.replace(url)
    } else {
      url === 'BACK' ? $router.go(-1) : $router.push(url)
    }
  } else {
    window.location.href = url
  }
}

export function getUrl (url, $router) {
  // Make sure the href is right in hash mode
  if ($router && !$router._history && typeof url === 'string' && !/http/.test(url)) {
    return '#!' + url
  }
  return url && typeof url !== 'object' ? url : 'javascript:void(0);'
}

export function debounce (func, wait, immediate) {
  // immediate默认为false
  var timeout, args, context, timestamp, result

  var later = function () {
    // 当wait指定的时间间隔期间多次调用debounce返回的函数，则会不断更新timestamp的值，导致last < wait && last >= 0一直为true，从而不断启动新的计时器延时执行func
    var last = Date.now() - timestamp

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function () {
    context = this
    args = arguments
    timestamp = Date.now()
    // 第一次调用该方法时，且immediate为true，则调用func函数
    var callNow = immediate && !timeout
    // 在wait指定的时间间隔内首次调用该方法，则启动计时器定时调用func函数
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export const chunk = (arr, size) => Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => arr.slice(i * size, i * size + size))

// 补零
export function fillZero (val) {
  if (+val < 10) {
    return `0${val}`
  }
  return val
}

/**
 * 生成query字符串
 * @param query
 * @returns {string}
 */
export function queryBuilder (query) {
  if (typeof query !== 'object') {
    return ''
  }
  let queryStr = ''
  for (let key in query) {
    queryStr += `&${key}=${encodeURIComponent(query[key])}`
  }
  return queryStr.substr(1)
}

const CMX = CMX || {}
/**
 ** 加
 **/
CMX.add = function (arg1, arg2) {
  var r1, r2, m, c
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  c = Math.abs(r1 - r2)
  m = Math.pow(10, Math.max(r1, r2))
  if (c > 0) {
    var cm = Math.pow(10, c)
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace('.', ''))
      arg2 = Number(arg2.toString().replace('.', '')) * cm
    } else {
      arg1 = Number(arg1.toString().replace('.', '')) * cm
      arg2 = Number(arg2.toString().replace('.', ''))
    }
  } else {
    arg1 = Number(arg1.toString().replace('.', ''))
    arg2 = Number(arg2.toString().replace('.', ''))
  }
  return (arg1 + arg2) / m
}

/**
 ** 减
 **/
CMX.sub = function (arg1, arg2) {
  var r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2)) // last modify by deeka //动态控制精度长度
  n = (r1 >= r2) ? r1 : r2
  return Number(((arg1 * m - arg2 * m) / m).toFixed(n))
}

/**
 ** 乘
 **/
CMX.mul = function (arg1, arg2) {
  var m = 0
  var s1 = arg1.toString()
  var s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {
  }
  try {
    m += s2.split('.')[1].length
  } catch (e) {
  }
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}

export { CMX }

// 分享
export async function share (context, [{
  friendsTitle, friendsDesc, friendsImgUrl
}, {
  friendCircleTitle, friendCircleImgUrl
}]) {
  let { code, obj, msg } = await context.$http('smarthos.wechat.jsapiticket.get', {
    appid: getENV().appid,
    reqUrl: window.location.href
  })
  if (code === '0') {
    wx.config(obj)
    // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
    wx.ready(function () {
      // 需在用户可能点击分享按钮前就先调用
      wx.updateAppMessageShareData({
        title: friendsTitle, // 分享标题
        desc: friendsDesc, // 分享描述
        imgUrl: friendsImgUrl, // 分享图标
        link: `${window.location.href}?source=share`// 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      }, function (res) {
        // 这里是回调函数
        Log('分享给朋友：', res)
      })
      // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
      wx.updateTimelineShareData({
        title: friendCircleTitle, // 分享标题
        link: `${window.location.href}?source=share`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: friendCircleImgUrl // 分享图标
      }, function (res) {
        // 这里是回调函数
        Log('分享到朋友圈：', res)
      })
    })
  } else {
    context.$emit('msg', msg)
  }
}

// 获取查询参数
export function getQueryParams () {
  let { href } = window.location
  let idx = href.lastIndexOf('?')
  let str = href.slice(idx + 1)
  let query = {}
  str.split('&').forEach(item => {
    let [key, val] = item.split('=')
    query[key] = val
  })
  return query
}

export async function goBack (context) {
  let query = getQueryParams()
  if (['share', 'push'].includes(query.source)) {
    let { code, obj, msg } = await context.$http('smarthos.wechat.jsapiticket.get', {
      appid: getENV().appid,
      reqUrl: window.location.href
    })
    if (code === '0') {
      wx.config(obj)
      // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      wx.ready(function () {
        // 关闭网页
        wx.closeWindow()
      })
    }
  } else {
    go('BACK', context.$router)
  }
}

/**
 * 预览图片 微信SDK
 * @param context
 * @param current
 * @param urls
 * @returns {Promise<void>}
 */
export async function previewImage (context, current, urls) {
  console.log(current)
  console.log(urls)

  let { code, obj, msg } = await context.$http('smarthos.wechat.jsapiticket.get', {
    appid: getENV().appid,
    reqUrl: window.location.href
  })
  if (code === '0') {
    wx.config(obj)
    wx.previewImage({
      current: current, // 当前显示图片的http链接
      urls: urls // 需要预览的图片http链接列表
    })
  } else {
    context.$emit('msg', msg)
  }
}

/**
 * 关闭微信页面
 * @returns {Promise<void>}
 */
export async function closeWX (context) {
  console.log('关闭微信页面')
  let { code, obj, msg } = await context.$http('smarthos.wechat.jsapiticket.get', {
    appid: getENV().appid,
    reqUrl: window.location.href
  })
  if (code === '0') {
    wx.config(obj)
    wx.closeWindow();
  } else {
    console.log(msg)
    setTimeout(function() {
      //这个可以关闭安卓系统的手机
      document.addEventListener(
        "WeixinJSBridgeReady",
        function() {
          WeixinJSBridge.call("closeWindow");
        },
        false
      );
      //这个可以关闭ios系统的手机
      WeixinJSBridge.call("closeWindow");
      }, 300)
    }
}

/**
 * js数据类型判断
 * @param data
 * @returns {string}
 */
export function getDataType (data) {
  return Object.prototype.toString.call(data).replace(/(\[object\s)|\]/g, '')
}

// 是否朴素对象
export function isPlainObject (obj) {
  if (getDataType(obj) === 'Object') {
    let keys = Object.keys(obj)
    return keys.length === 0
  }
  return false
}

/**
 * 时间格式字符串转换
 * yyyy-MM-dd ==> yyyy/MM/dd
 * @param str
 * @returns {string}
 */
export function formatDateStr (str) {
  let retStr = ''
  if (!str) return ''
  retStr = str.split('-').map(r => parseInt(r)).join('/')
  Log(`${str}==>${retStr}`)
  return retStr
}

/**
 * 处理消息列表5分钟间隔问题
 * @param list
 * @returns {any[]}
 */
export function handlerMsgCreateTime (list = []) {
  let tmp = 0
  return list.map(r => {
    const ctime = r.createTime || 0
    Log('ctime', ctime, tmp, ctime - tmp)
    if (r.msgLevel !== 'SYS' && ctime - tmp > 5 * 60 * 1000) {
      tmp = ctime
      r.showCreateTime = true
    } else r.showCreateTime = false
    return r
  })
}

/**
 * 生成分享链接
 * @param link
 * @returns {string}
 */
export function getShareLink (link) {
  if (!link) link = location.href
  let options = getParamsFromUrl(link)
  options.query.source = 'share'
  return makeUrl(options)
}

export function transHtml (str) {
  let div = document.createElement('div')
  div.innerHTML = str
  return div.innerHTML
}

// 此功能暂未开放开关
export function switchOpen (condition, cb) {
  if (condition) {
    bus.$emit('msg', '正在努力研发中，敬请期待')
  } else {
    cb && cb()
  }
}

export function makeAvator (sex = 'N', type = 'doc') {
  const sourceMap = type === 'doc' ? {
    M: require('Assets/img/doctorM.png'),
    N: require('Assets/img/doctorN.png'),
    F: require('Assets/img/doctorF.png'),
    T: require('Assets/img/doctorT.png') // 团队
  } : {
      M: require('Assets/img/my/pat-m.png'),
      N: require('Assets/img/my/pat-n.png'),
      F: require('Assets/img/my/pat-f.png')
    }
  const upperCase = sex.toUpperCase()
  return sourceMap[upperCase]
}

/**
 * 获得js数据类型
 * @param data
 * @returns {string}
 */
export function getJsDataType (data) {
  let type = Object.prototype.toString.call(data)
  type = type.toLowerCase()
  return type.replace(/\[object\s|\]/g, '')
}

/**
 * 空值判断
 * @param data
 * @returns {boolean}
 */
export function isEmpty (data) {
  const type = getJsDataType(data)
  console.log('type', type)
  let ret
  switch (type) {
    case 'number':
      ret = data === 0
      break
    case 'array':
      ret = data.length === 0
      break
    case 'object':
      ret = Object.keys(data).length === 0
      break
    case 'string':
      data = data.replace(/\s/g, '')
      if (data === 'null' || data === 'undefined' || data === '0') ret = true
      else ret = data.length === 0
      break
    case 'null':
    case 'undefined':
      ret = true
      break
    default:
      ret = false
  }
  return ret
}

export function findWlmzType (yyid) {
  let hosObj = HosCache.get()
  console.log('isWlzmType', hosObj[yyid].isWlzmType)
  return hosObj[yyid].isWlzmType
}

/**
 * 解析微信支付返回参数
 * @param msg
 * @returns {string}
 */
export function parsePayErrMsg (msg) {
  Log('msg类型', getDataType(msg))
  let ret
  switch (getDataType(msg)) {
    case 'Undefined':
      ret = undefined
      break
    case 'Array':
      ret = msg[msg.length - 1]
      break
    case 'String':
      ret = msg
      break
  }
  return ret
}


/**
 * 民族参数
 * @param msg
 * @returns {string}
 */
export const mzType = [
    {
      cardName:'汉族',
      cardType:'01'
    },
    {
      cardName:'蒙古族',
      cardType:'02'
    },
    {
      cardName:'回族',
      cardType:'03'
    },
    {
      cardName:'藏族',
      cardType:'04'
    },
    {
      cardName:'维吾尔族',
      cardType:'05'
    },
    {
      cardName:'苗族',
      cardType:'06'
    },
    {
      cardName:'彝族',
      cardType:'07'
    },
    {
      cardName:'壮族',
      cardType:'08'
    },
    {
      cardName:'布依族',
      cardType:'09'
    },
    {
      cardName:'朝鲜族',
      cardType:'10'
    },
    {
      cardName:'满族',
      cardType:'11'
    },
    {
      cardName:'侗族',
      cardType:'12'
    },
    {
      cardName:'瑶族',
      cardType:'13'
    },
    {
      cardName:'白族',
      cardType:'14'
    },
    {
      cardName:'土家族',
      cardType:'15'
    },
    {
      cardName:'哈尼族',
      cardType:'16'
    },
    {
      cardName:'哈萨克族',
      cardType:'17'
    },
    {
      cardName:'傣族',
      cardType:'18'
    },
    {
      cardName:'黎族',
      cardType:'19'
    },
    {
      cardName:'傈僳族',
      cardType:'20'
    },
    {
      cardName:'佤族',
      cardType:'21'
    },
    {
      cardName:'畲族',
      cardType:'22'
    },
    {
      cardName:'高山族',
      cardType:'23'
    },
    {
      cardName:'拉祜族',
      cardType:'24'
    },
    {
      cardName:'水族',
      cardType:'25'
    },
    {
      cardName:'东乡族',
      cardType:'26'
    },
    {
      cardName:'纳西族',
      cardType:'27'
    },
    {
      cardName:'景颇族',
      cardType:'28'
    },


    {
      cardName:'土族',
      cardType:'30'
    },
    {
      cardName:'达尔族',
      cardType:'31'
    },
    {
      cardName:'仫佬族',
      cardType:'32'
    },
    {
      cardName:'羌族',
      cardType:'33'
    },
    {
      cardName:'布朗族',
      cardType:'34'
    },
    {
      cardName:'撒拉族',
      cardType:'35'
    },
    {
      cardName:'毛南族',
      cardType:'36'
    },
    {
      cardName:'仡佬族',
      cardType:'37'
    },
    {
      cardName:'锡伯族',
      cardType:'38'
    },
    {
      cardName:'阿昌族',
      cardType:'39'
    },
    {
      cardName:'普米族',
      cardType:'40'
    },
    {
      cardName:'塔吉克族',
      cardType:'41'
    },
    {
      cardName:'怒族',
      cardType:'42'
    },
    {
      cardName:'乌孜别克族',
      cardType:'43'
    },
    {
      cardName:'俄罗斯族',
      cardType:'44'
    },
    {
      cardName:'鄂温克族',
      cardType:'45'
    },
    {
      cardName:'德昂族',
      cardType:'46'
    },
    {
      cardName:'保安族',
      cardType:'47'
    },
    {
      cardName:'裕固族',
      cardType:'48'
    },
    {
      cardName:'京族',
      cardType:'49'
    },
    {
      cardName:'塔塔尔族',
      cardType:'50'
    },
    {
      cardName:'独龙族',
      cardType:'51'
    },
    {
      cardName:'鄂伦春族',
      cardType:'52'
    },
    {
      cardName:'赫哲族',
      cardType:'53'
    },
    {
      cardName:'门巴族',
      cardType:'54'
    },
    {
      cardName:'珞巴族',
      cardType:'55'
    },
    {
      cardName:'基诺族',
      cardType:'56'
    },
    {
      cardName:'其他未识别的民族',
      cardType:'97'
    }
]



// WEBPACK FOOTER //
// ./src/lib/utils.js